<template>
  <div v-if="showName == ''"></div>
  <div v-else>
    <div v-show="showName === 'ma190727'" class="study">
      <div class="way">
        <div class="computer">
          <ul>
            <li>
              <span>电脑听课网址：</span
              ><a
                target="_blank"
                href="http://shanhe.ahumooc.com/index/index.html"
                >点击链接听课</a
              >
            </li>
            <li>
              <span>登录听课账号：{{ $store.state.user.profile.phone }}</span>
            </li>
            <li>
              <span
                >登录账号密码：初次登录请使用手机验证码，之后可以设置初始密码</span
              >
            </li>
          </ul>
        </div>
        <div class="phone">
          <ul>
            <li>
              <span>手机听课APP下载二维码：</span
              ><img
                src="../../../../../public/imgs/阿虎医考山河医学网APP下载二维码.png"
                alt=""
              />
            </li>
            <li>
              <span>登录听课账号：{{ $store.state.user.profile.phone }}</span>
            </li>
            <li>
              <span
                >登录账号密码：初次登录请使用手机验证码，之后可以设置初始密码</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-show="showName === 'ma055618'" class="study">
      <div class="way">
        <div class="computer">
          <ul>
            <li>
              <span>电脑听课网址：</span
              ><a target="_blank" href="https://hzs.ksbao.com/login?ac=055618"
                >点击链接听课</a
              >
            </li>
            <li>
              <span>登录听课账号：{{ $store.state.user.profile.phone }}</span>
            </li>
            <li>
              <span
                >登录账号密码：初次登录请使用手机验证码，之后可以设置初始密码</span
              >
            </li>
          </ul>
        </div>
        <div class="phone">
          <ul>
            <li>
              <span>手机听课APP下载：在手机应用市场搜索“考试宝典”下载安装</span>
            </li>
            <li>
              <span>登录听课账号：{{ $store.state.user.profile.phone }}</span>
            </li>
            <li>
              <span
                >登录账号密码：初次登录请使用手机验证码，之后可以设置初始密码</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-show="showName === 'ma025000'" class="study">
      <div class="way">
        <div class="computer">
          <ul>
            <li>
              <span>电脑听课网址：</span
              ><a target="_blank" href="http://h.yijiayk.com/#/"
                >点击链接听课</a
              >
            </li>
            <li>
              <span>登录听课账号：{{ $store.state.user.profile.phone }}</span>
            </li>
            <li>
              <span
                >登录账号密码：初次登录请使用手机验证码，之后可以设置初始密码</span
              >
            </li>
          </ul>
        </div>
        <div class="phone">
          <ul>
            <li>
              <span>手机听课APP下载二维码：</span
              ><img
                src="../../../../../public/imgs/有猿医家山河医学网APP下载二维码.png"
                alt=""
              />
            </li>
            <li>
              <span>登录听课账号：{{ $store.state.user.profile.phone }}</span>
            </li>
            <li>
              <span
                >登录账号密码：初次登录请使用手机验证码，之后可以设置初始密码</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-show="showName === 'ma020000'" class="study">
      <div class="way">
        <div class="computer">
          <ul>
            <li>
              <span>电脑听课网址：</span
              ><a
                target="_blank"
                href="https://h5.zhukao.com.cn/index1.php?m=Product&a=selectKeMu&agentId=0&g=zhukao&f=Browser&fp=N&userAgree=B&sysType=1&domain=zkzx"
                >点击链接听课</a
              >
            </li>
            <li>
              <span>登录听课账号：{{ $store.state.user.profile.phone }}</span>
            </li>
            <li>
              <span
                >登录账号密码：初次登录请使用手机验证码，之后可以设置初始密码</span
              >
            </li>
          </ul>
        </div>
        <div class="phone">
          <ul>
            <li>
              <span>手机听课APP下载：在手机应用市场搜索“助考之星”下载安装</span>
            </li>
            <li>
              <span>登录听课账号：{{ $store.state.user.profile.phone }}</span>
            </li>
            <li>
              <span
                >登录账号密码：初次登录请使用手机验证码，之后可以设置初始密码</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { ref, computed, reactive, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    showName: {
      type: String,
      default: () => "",
    },
  },
  setup() {
    const store = useStore();
    //const activeName = ref();

    return {};
  },
};
</script>

<style lang="less" scoped>
.study {
  margin-top: 8px;
  .way {
    height: 300px;
    display: flex;
    justify-content: space-between;
    .computer {
      width: 600px;
      margin-left: 8px;
      border-radius: 8px;
      margin-bottom: 8px;
      border: 1px solid #dedede;
      display: flex;
      justify-content: center;
      align-items: center;
      li {
        margin-top: 8px;
        span {
          font-size: 18px;
        }
        a {
          font-size: 18px;
          color: @shColor;
        }
      }
    }
    .phone {
      width: 600px;
      margin-right: 8px;
      border-radius: 8px;
      margin-bottom: 8px;
      border: 1px solid #dedede;
      display: flex;
      justify-content: center;
      align-items: center;
      li {
        margin-top: 8px;
        span {
          font-size: 18px;
        }
        img {
          width: 120px;
          height: 120px;
        }
      }
    }
  }
}
</style>
